import { pluralize } from '@libs/i18n';
import { TournamentShortDto } from '@features/landing/grandprix/typings';

const roundsPluralConfig = {
  many: 'туров',
  few: 'тура',
  one: 'тур',
  zero: 'туров',
};

type Props = {
  tournament: Pick<TournamentShortDto, 'system' | 'swissSettings'>;
};

export function RoundsCount({ tournament }: Props) {
  if (tournament.system !== 'Swiss') {
    return null;
  }

  const count = tournament.swissSettings.roundsCount;

  return (
    <>
      {count}&nbsp;{pluralize(roundsPluralConfig, count)}
    </>
  );
}
